import { useLocation } from '@gatsbyjs/reach-router';
import { useEffect } from 'react';
import {
  removeLocalStorageItem,
  setLocalStorageItem,
} from '~/util/localStorageKeys';

type Options = {
  /**
   * The URL parameter name to extract (e.g., 'signupId', 'ref', 'couponCode')
   */
  paramName: string;
  /**
   * The localStorage key to store the value under
   */
  storageKey: string;
};

/**
 * Always update the localStorage item to a value
 */
const useStoreUrlParam = ({ paramName, storageKey }: Options) => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramValue = params.get(paramName);

    if (paramValue === '') {
      removeLocalStorageItem(storageKey);
      return;
    }

    if (paramValue) {
      setLocalStorageItem(
        storageKey,
        JSON.stringify({ [paramName]: paramValue }),
      );
    }
  }, [location.search, paramName, storageKey]);
};

export default useStoreUrlParam;
